var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEfexBranco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 420.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m59.85,285.74c33.05,0,59.85.43,59.85.96s-26.8.96-59.85.96-59.85-.43-59.85-.96,26.8-.96,59.85-.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m440.15,285.74c33.05,0,59.85.43,59.85.96s-26.8.96-59.85.96-59.85-.43-59.85-.96,26.8-.96,59.85-.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m182.87,307.65c-3.83,3.12-8.91,4.81-15.06,4.81-10.79,0-16.94-6.95-19.88-10.34l5.08-5.79c3.12,4.19,8.91,8.82,15.6,8.82s12.03-3.83,12.03-10.34-6.86-8.91-9.98-10.16c-3.21-1.25-7.49-2.94-9.81-4.1-1.34-.62-3.92-1.96-6.15-4.37-2.23-2.32-4.01-5.71-4.01-10.7s2.32-9.09,5.62-11.86c3.39-2.85,8.2-4.55,14.17-4.55,10.07,0,15.96,6.15,17.65,7.93l-4.55,5.88c-3.03-3.21-7.49-6.6-13.55-6.6s-10.7,2.85-10.7,8.56,4.19,7.84,7.93,9.36l11.32,4.72c1.16.54,4.9,2.59,6.95,4.99,1.96,2.41,3.74,5.71,3.74,10.34,0,5.35-2.41,10.07-6.42,13.37"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 199.27,
    y: 249.89,
    width: 8.65,
    height: 61.51
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "255.61 257.11 230.11 257.11 230.11 277.61 254.09 277.61 254.09 284.83 230.11 284.83 230.11 311.39 221.47 311.39 221.47 249.89 255.61 249.89 255.61 257.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m312.57,311.39h-9.63l-6.33-16.05h-26.39l-6.33,16.05h-9.09l25.05-61.69h7.58l25.14,61.69Zm-18.36-23.27l-10.79-27.63-10.79,27.63h21.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "348.58 257.11 331.29 257.11 331.29 311.39 322.64 311.39 322.64 257.11 305.26 257.11 305.26 249.89 348.58 249.89 348.58 257.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.95 420.03 11.93 420.03 11.93 332.9 62.94 332.9 62.94 343.13 24.18 343.13 24.18 369.14 60.79 369.14 60.79 379.37 24.18 379.37 24.18 409.67 63.95 409.67 63.95 420.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "127.33 343.13 91.22 343.13 91.22 372.17 125.19 372.17 125.19 382.4 91.22 382.4 91.22 420.03 78.97 420.03 78.97 332.9 127.33 332.9 127.33 343.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "193.37 420.03 141.35 420.03 141.35 332.9 192.36 332.9 192.36 343.13 153.6 343.13 153.6 369.14 190.21 369.14 190.21 379.37 153.6 379.37 153.6 409.67 193.37 409.67 193.37 420.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "272.16 420.03 257.39 420.03 235.29 383.03 213.32 420.03 198.67 420.03 227.46 375.08 200.69 332.9 215.09 332.9 235.29 366.87 255.62 332.9 270.01 332.9 243.24 375.08 272.16 420.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m327.09,376.46c-5.3,4.55-12.63,6.19-21.09,6.19h-12.25v37.38h-12.25v-87.13h24.5c8.46,0,15.78,1.64,21.09,6.19,5.43,4.67,8.46,10.35,8.46,18.69s-3.03,14.14-8.46,18.69m-9.47-30.18c-3.16-2.27-7.07-3.41-12.63-3.41h-11.24v29.8h11.24c5.56,0,9.47-1.14,12.63-3.28,3.03-2.27,5.3-6.19,5.3-11.62s-2.27-9.34-5.3-11.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m407.39,408.66c-6.31,5.81-17.43,11.36-32.58,11.36h-26.26v-87.13h26.26c15.15,0,26.26,5.56,32.58,11.36,6.31,5.81,13.51,15.91,13.51,32.2s-7.2,26.39-13.51,32.2m-9.34-57.2c-4.8-4.55-12.63-8.08-23.23-8.08h-14.02v66.04h14.02c10.61,0,18.43-3.54,23.23-8.08,4.8-4.55,10.35-12.25,10.35-24.88s-5.56-20.46-10.35-25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "497.54 332.9 465.47 420.15 454.61 420.15 422.54 332.9 435.67 332.9 460.17 402.35 484.67 332.9 497.54 332.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "305.01 82.74 341.54 133.15 173.12 133.15 173.12 165.91 352.88 165.91 387.98 216.31 122.71 216.31 122.71 82.74 305.01 82.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "295.28 50.4 122.71 50.4 122.71 0 262.33 0 295.28 50.4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEfexBranco);
export default __webpack_public_path__ + "static/media/Efex - Branco.323d43bd3985c7068ba8c22019106036.svg";
export { ForwardRef as ReactComponent };